import { render, staticRenderFns } from "./Tickets.vue?vue&type=template&id=041709de&scoped=true"
import script from "./Tickets.vue?vue&type=script&lang=js"
export * from "./Tickets.vue?vue&type=script&lang=js"
import style0 from "@/assets/css/inbox.css?vue&type=style&index=0&id=041709de&prod&scoped=true&lang=css&external"
import style1 from "./Tickets.vue?vue&type=style&index=1&id=041709de&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "041709de",
  null
  
)

export default component.exports